import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import ExpandIco from "../../assets/icons/ExpandIco";
import CommonButton from "../../component/Button";
import { CustomDiv } from "../chat-bot/style";
import { CommonGrid2 } from "./StyledComponents";

function CommonAccordion({
  title,
  children,
  onButtonClick,
  accordionButton = false,
  buttonTitle,
  loading,
  disabled,
  open,
  onChange,
  defaultOpen,
  customStyle,
  icon,
  CustomButton,
  wholeborder,
  buttonborder,
  fontWeight,
  customStyleButton,
  variant,
}) {
  const lg = useMediaQuery("(min-width:767px)");

  return (
    <Accordion
      key={title}
      defaultExpanded={defaultOpen}
      expanded={open}
      onChange={onChange}
      sx={{
        boxShadow: "none",
        "&:before": {
          display: "none",
        },
        "& .MuiCollapse-wrapper": {
          padding: lg ? "0.5rem 1rem 1rem" : "0.5rem 0rem 0px",
        },
        // "& .MuiAccordion-heading .MuiAccordionSummary-content .MuiButtonBase-root":
        //   {
        //     borderRadius: "10px",
        //     // padding: lg ? "0px 16px" : "0px",
        //   },
        ...(!lg && {
          "& .MuiCollapse-root": {
            padding: "0px 10px",
          },
        }),

        ...customStyle,
        border: wholeborder || "1px solid #EAECF0",
        borderRadius: `${lg ? 10 : 7}px !important`,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandIco />}
        aria-controls="panel1-content"
        id={`${title}`}
        sx={{
          background: "#fff",
          gap: "1.5rem",
          "& .MuiAccordionSummary-expandIconWrapper": {
            ...(buttonborder
              ? {
                  border: "1px solid #D0D5DD",
                  padding: "15px",
                  borderRadius: "7px",
                }
              : { border: "none" }),
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            justifyContent: "space-between",
          },
          "& .MuiAccordionSummary-content": {
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            width: "100%",
            margin: accordionButton
              ? "8px 0px !important"
              : "14px 0px !important",
            justifyContent: "space-between",
          },
          "& .MuiCollapse-wrapper": {
            padding: "10px",
          },
        }}
        onClick={(e) => {
          console.log("kdnffnsfglkmn");
          if (!e.target.closest(".expand-icon")) {
            e.stopPropagation();
          }
        }}
      >
        <CommonGrid2
          display={"flex"}
          alignItems={"center"}
          gap={lg ? "1rem" : "10px"}
          width="auto"
        >
          {icon && <CustomDiv display="flex">{icon}</CustomDiv>}
          <Typography
            variant={variant ? variant : lg ? "h4" : "h6"}
            fontWeight={fontWeight || 600}
            color={"#101828"}
            display={"flex"}
            alignItems={"center"}
            width={"100%"}
          >
            {title}
          </Typography>
        </CommonGrid2>
        {accordionButton &&
          (CustomButton ? (
            CustomButton
          ) : (
            <CommonButton
              variant="outlined"
              color="#344054"
              border="#D0D5DD"
              fontWeight="600"
              value={buttonTitle}
              padding="8px 16px"
              fullWidth
              onClick={(e) => {
                e.stopPropagation();
                onButtonClick && onButtonClick();
              }}
              customStyle={{
                pointerEvents: "all",
                cursor: "pointer",
                ...customStyleButton,
              }}
              loading={loading}
              disabled={disabled}
            />
          ))}
      </AccordionSummary>
      <AccordionDetails sx={{ padding: "0px" }}>{children}</AccordionDetails>
    </Accordion>
  );
}

export default CommonAccordion;
